import { calcAge } from "./ageUtils";
import { validatePatientWithConfig } from "./sectionConfiguration";

export function validatePatientSubmit(patient, config) {
  const errors = config?.sections
    ? validatePatientWithConfig(patient, config)
    : {};

  if (!config?.sections) {
    if (!patient.name?.trim()) errors.name = "Name is required";
    if (!patient.gender) errors.gender = "Gender is required";
    if (!patient.dob) errors.dob = "Date of birth is required";
    if (!patient.primaryMobile?.trim()) {
      errors.primaryMobile = "Primary mobile is required";
    } else if (!/^\d{10}$/.test(patient.primaryMobile.replace(/\D/g, ""))) {
      errors.primaryMobile = "Enter a valid 10-digit mobile number";
    }
    if (!patient.encounter?.admittingDoctorId) {
      errors.admittingDoctor = "Admitting doctor is required";
    }
  }

  (patient.documents || []).forEach((doc, index) => {
    const numberError = getDocumentNumberError(doc.type, doc.number);
    if (numberError) {
      errors[`documents.${index}.number`] = numberError;
    }
  });

  return { valid: Object.keys(errors).length === 0, errors };
}

export function isSeniorCitizen(dob) {
  const age = calcAge(dob);
  return age != null && age >= 60;
}

export function validateAadhaar(value) {
  return /^\d{12}$/.test(value);
}

export function validateOtp(value) {
  return /^\d{6}$/.test(value);
}

export function validateMobile(value) {
  return /^\d{10}$/.test(value);
}

export function validateAbhaNumber(value) {
  return /^\d{2}-?\d{4}-?\d{4}-?\d{4}$/.test((value || "").trim());
}

/** Length rules for Patient Documents → Document Number by Document Type. */
const DOCUMENT_NUMBER_LENGTH = {
  PAN: { min: 10, max: 10, label: "10 characters" },
  PASSPORT: { min: 6, max: 9, label: "6–9 characters" },
  VOTER_ID: { min: 10, max: 10, label: "10 characters" },
  AADHAAR: { min: 12, max: 12, label: "12 characters" },
  IQAMA: { min: 10, max: 10, label: "10 characters" },
  ABHA_CARD: { min: 12, max: 12, label: "12 characters" },
  ABHA: { min: 12, max: 12, label: "12 characters" },
};

export function getDocumentNumberLengthRule(type) {
  return DOCUMENT_NUMBER_LENGTH[String(type || "").trim().toUpperCase()] || null;
}

/**
 * Returns an error message if the document number fails the type length rule,
 * or null when valid / no rule / empty.
 */
export function getDocumentNumberError(type, number) {
  const value = String(number || "").trim();
  if (!value) return null;
  const rule = getDocumentNumberLengthRule(type);
  if (!rule) return null;
  const len = value.length;
  if (len < rule.min || len > rule.max) {
    const typeLabel = String(type || "").replace(/_/g, " ");
    return `${typeLabel} number must be ${rule.label}`;
  }
  return null;
}
